import * as Validation from "../../../common/utils/Validation";
import {addEditDPActionTypes} from "../../../veritas/add-edit/constants/AddEditActionConstants";
import {checkUpdateTimeActionTypes} from "../constants/UtilityMiddlewareConstants";
import {apiActionsDP} from "../constants/ApiMiddlewareConstants";

/**
 * This is the Middleware to validate the object generated by the add/edit DP modal.
 * @param store, action
 * @returns Makes the call to custom validation procedure and conditionally dispatches
 * the check-update action or the post action
 */
const validateDataProviderFormMiddleware = (store) => (next) => (action) => {

    switch (action.type) {

        case addEditDPActionTypes.VALIDATE_DATA_PROVIDER_FORM: {
            next(action);
            const { providerObject, authToken } = action.payload;
            // FEAT-61 Changes - the object is redefined at the API level such
            // that we are no longer required to format it here like before.

            // Call the custom validation for the fields.
            if (Validation.validateDPForm(providerObject)) {
                // check if the redux action dispatched is for editing the data provider
                if (providerObject.provider_detail.provider_id) {
                    const dataProviderID = providerObject.provider_detail.provider_id;
                    store.dispatch({
                        type: checkUpdateTimeActionTypes.DATA_PROVIDER,
                        payload: { dataProviderID, providerObject, authToken }
                    })
                } else {
                    store.dispatch({
                        type: apiActionsDP.POST,
                        payload: { providerObject, authToken }
                    })
                }
            }

            break;
        }

        default: next(action)
    }
}

export default validateDataProviderFormMiddleware;
